export default function loadEnv() {
  var innerText;
  try {
    var envScript = document.getElementById('ENV');
    if (envScript) {
      innerText = envScript.innerText;
      var envData = JSON.parse(innerText);
      Object.assign(process.env, envData);
      if (envData.WEBPACK_PUBLIC_PATH) {
        __webpack_public_path__ = envData.WEBPACK_PUBLIC_PATH.replace(/[^/]$/, '$&/');
      }
    }
  } catch (e) {
    console.error('Failed to load environment variables:', e, {
      innerText: innerText
    });
    throw e;
  }
}